import tinycolor from "tinycolor2";

const THEME = [
  {
    NAME: "Default",
    PROPERTY: {
      BACKGROUND: {
        DEFAULT: "#f2f2f2",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#ebebeb",
        SUCCESS: "#62d898",
        INFO: "#fff",
        WARNING: "#ebebeb",
        DARK: "#f0f3ff",
        LIGTH: "#f0f3ff",
        BEACH: "#f5f7ff",
        SUNSHINE: "#fff",
        DASHBOARD: "#ebebeb",
      },
      COLOR: {
        DEFAULT: "#6c88ff",
        PRIMARY: "#fff",
        DANGER: "#fff",
        SECONDARY: "#000",
        SUCCESS: "#fff",
        INFO: "#000",
        WARNING: "",
        DARK: "#6c88ff",
        LIGTH: "#6c88ff",
        BEACH: "#000",
        SUNSHINE: "",
        DASHBOARD: "",
      },
      BORDER: {
        DEFAULT: "#f2f2f2",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#e8e8e8",
        SUCCESS: "",
        INFO: "#000",
        WARNING: "#e8e8e8",
        DARK: "#e8e8e8",
        LIGTH: "#6c88ff",
        BEACH: "",
        SUNSHINE: "",
        DASHBOARD: "",
      },
    },
  },
  {
    NAME: "Dark",
    PROPERTY: {
      BACKGROUND: {
        DEFAULT: "#505ea3",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#273164",
        SUCCESS: "#62d898",
        INFO: "#394581",
        WARNING: "#505c9b",
        DARK: "#505ea3",
        LIGTH: "#6271B9",
        BEACH: "#505c9b",
        SUNSHINE: "#394581",
        DASHBOARD: "#273164",
      },
      COLOR: {
        DEFAULT: "#fff",
        PRIMARY: "#fff",
        DANGER: "#fff",
        SECONDARY: "#fff",
        SUCCESS: "#fff",
        INFO: "#fff",
        WARNING: "",
        DARK: "#fff",
        LIGTH: "#fff",
        BEACH: "#fff",
        SUNSHINE: "",
        DASHBOARD: "",
      },
      BORDER: {
        DEFAULT: "#505ea3",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#505c9b",
        SUCCESS: "",
        INFO: "#fff",
        WARNING: "#505c9b",
        DARK: "#5b6ab5",
        LIGTH: "#fff",
        BEACH: "",
        SUNSHINE: "",
        DASHBOARD: "",
      },
    },
  },
  {
    NAME: "Dark Green",
    PROPERTY: {
      BACKGROUND: {
        DEFAULT: "#6095a5",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#383838",
        SUCCESS: "#62d898",
        INFO: "#397081",
        WARNING: "#5c90a0",
        DARK: "#548898",
        LIGTH: "#6095a5",
        BEACH: "#5c90a0",
        SUNSHINE: "#397081",
        DASHBOARD: "#383838",
      },
      COLOR: {
        DEFAULT: "#fff",
        PRIMARY: "#fff",
        DANGER: "#fff",
        SECONDARY: "#fff",
        SUCCESS: "#fff",
        INFO: "#fff",
        WARNING: "",
        DARK: "#fff",
        LIGTH: "#fff",
        BEACH: "#fff",
        SUNSHINE: "",
        DASHBOARD: "",
      },
      BORDER: {
        DEFAULT: "#548898",
        PRIMARY: "#6c88ff",
        DANGER: "#ff6c6c",
        SECONDARY: "#5c90a0",
        SUCCESS: "",
        INFO: "#fff",
        WARNING: "#5c90a0",
        DARK: "#6499aa",
        LIGTH: "#fff",
        BEACH: "",
        SUNSHINE: "",
        DASHBOARD: "",
      },
    },
  },
  {
    NAME: "Custom",
    PROPERTY: {
      BACKGROUND: {
        DEFAULT: "color1/hsl(x, 28%, 51%)",
        PRIMARY: "color2/hsl(x, 100%, 40%)",
        DANGER: "#383838",
        SECONDARY: "color2/hsl(x, 30%, 25%)",
        SUCCESS: "color1/hsl(x, 100%, 40%)",
        INFO: "color1/hsl(x, 39%, 36%)",
        WARNING: "color1/hsl(x, 27%, 49%)",
        DARK: "color2/hsl(x, 29%, 46%)",
        LIGTH: "color1/hsl(x, 28%, 51%)",
        BEACH: "color1/hsl(x, 27%, 49%)",
        SUNSHINE: "color2/hsl(x, 39%, 36%)",
        DASHBOARD: "color2/hsl(x, 30%, 25%)",
      },
      COLOR: {
        DEFAULT: "#fff",
        PRIMARY: "#fff",
        DANGER: "#fff",
        SECONDARY: "#fff",
        SUCCESS: "#fff",
        INFO: "#fff",
        WARNING: "",
        DARK: "#fff",
        LIGTH: "#fff",
        BEACH: "#fff",
        SUNSHINE: "",
        DASHBOARD: "",
      },
      BORDER: {
        DEFAULT: "color1/hsl(x, 29%, 46%)",
        PRIMARY: "color2/hsl(x, 100%, 40%)",
        DANGER: "#383838",
        SECONDARY: "color1/hsl(x, 27%, 49%)",
        SUCCESS: "color1/hsl(x, 29%, 53%)",
        INFO: "#fff",
        WARNING: "color1/hsl(x, 27%, 49%)",
        DARK: "color2/hsl(x, 29%, 53%)",
        LIGTH: "#fff",
        BEACH: "",
        SUNSHINE: "",
        DASHBOARD: "",
      },
    },
  },
];

function calculatorColor(color1, color2, object) {
  let myMap = {};
  for (let [key, value] of Object.entries(object.PROPERTY)) {
    let myMap2 = {};
    for (let [key2, value2] of Object.entries(value)) {
      let colorKey = value2.split("/");
      if (colorKey[1]) {
        if (colorKey[0] === "color1") {
          if (color1 === "#ffffff") {
            let hsl_Array = colorKey[1].split(",");
            value2 = `hsl(0, 0%, ${hsl_Array[2]}`;
          } else {
            let hslColor = tinycolor(color1).toHsl();
            let hueColor = Math.round(hslColor.h).toString();
            value2 = colorKey[1].replace("x", hueColor);
          }
        } else {
          if (color2 === "#ffffff") {
            let hsl_Array = colorKey[1].split(",");
            if (key2 === "DASHBOARD") {
              value2 = "hsl(0, 0%, 100%)";
            } else {
              value2 = `hsl(0, 0%, ${hsl_Array[2]}`;
            }
          } else {
            let hslColor = tinycolor(color2).toHsl();
            let hueColor = Math.round(hslColor.h).toString();
            value2 = colorKey[1].replace("x", hueColor);
          }
        }
      }
      myMap2[key2] = value2.toString();
    }
    myMap[key] = myMap2;
  }
  object.PROPERTY = myMap;
  return object;
}

export { THEME, calculatorColor };
